import { LandingPage, Theme } from '../../global/types'

export const CREATE_LANDING_PAGE = 'HOME/CREATE_LANDING_PAGE'
export const CREATE_LANDING_PAGE_SUCCESS = 'HOME/CREATE_LANDING_PAGE_SUCCESS'
export const CREATE_LANDING_PAGE_FAIL = 'HOME/CREATE_LANDING_PAGE_FAIL'
export const LANDING_PAGE_CLEAR_ERROR = 'HOME/LANDING_PAGE_CLEAR_ERROR'
export const ADD_LANDING_PAGE = 'HOME/ADD_LANDING_PAGE'
export const ADD_THEME = 'HOME/ADD_THEME'

export const createLandingPage = (
  countryId: number,
  name: string,
  path: string,
) => ({
  type: CREATE_LANDING_PAGE,
  countryId,
  name,
  path,
})

export const landingPageClearError = () => ({
  type: LANDING_PAGE_CLEAR_ERROR,
})

export type AddLandingPage = {
  type: typeof ADD_LANDING_PAGE
  landingPage: LandingPage
}

export const addLandingPage = (landingPage: LandingPage): AddLandingPage => ({
  type: ADD_LANDING_PAGE,
  landingPage,
})

export type AddTheme = {
  type: typeof ADD_THEME
  theme: Theme
}
export const addTheme = (theme: Theme): AddTheme => ({
  type: ADD_THEME,
  theme,
})
